import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 24px;
  text-align: center;
`;

export const Title = styled.h2`
  margin: 0 0 8px;
  font-size: 1.25rem;
`;

export const Message = styled.p`
  margin: 0 0 20px;
  color: #666;
  font-size: 0.9375rem;
`;
